import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useCallback, useEffect } from 'react';
import styled from '@emotion/styled';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Search } from 'lucide-react';
import { X } from 'lucide-react';
import { MessageCircle } from 'lucide-react';
import { Clock } from 'lucide-react';
import { User } from 'lucide-react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { searchAllMessages, searchMessages } from '@edusense/people-chat/handlers/DM';
const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: var(--theme-paper, #ffffff);
  
  .dark & {
    background-color: var(--theme-paper, #1f2937);
  }
`;
const SearchHeader = styled.div`
  padding: 1rem;
  border-bottom: 1px solid var(--theme-border, #e5e7eb);
  flex-shrink: 0;
  
  .dark & {
    border-color: var(--theme-border, #374151);
  }
`;
const SearchInputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--theme-paper-hover, #f9fafb);
  border: 1px solid var(--theme-border, #e5e7eb);
  border-radius: 0.5rem;
  padding: 0.75rem;
  
  .dark & {
    background-color: var(--theme-paper-hover, #374151);
    border-color: var(--theme-border, #4b5563);
  }
`;
const SearchInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  color: var(--theme-text, #111827);
  font-size: 1rem;
  outline: none;
  margin-left: 0.5rem;

  &::placeholder {
    color: var(--theme-text-secondary, #6b7280);
  }

  .dark & {
    color: var(--theme-text, #f3f4f6);
    
    &::placeholder {
      color: var(--theme-text-secondary, #9ca3af);
    }
  }
`;
const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: var(--theme-text-secondary, #6b7280);
  padding: 0.25rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--theme-hover, rgba(0, 0, 0, 0.05));
  }

  .dark & {
    color: var(--theme-text-secondary, #9ca3af);
    
    &:hover {
      background-color: var(--theme-hover, rgba(255, 255, 255, 0.05));
    }
  }
`;
const SearchFilters = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
`;
const FilterButton = styled.button`
  padding: 0.25rem 0.75rem;
  border: 1px solid var(--theme-border, #e5e7eb);
  border-radius: 9999px;
  background-color: ${(props)=>props.active ? 'var(--theme-primary, #10b981)' : 'transparent'};
  color: ${(props)=>props.active ? 'white' : 'var(--theme-text, #111827)'};
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${(props)=>props.active ? 'var(--theme-primary-dark, #059669)' : 'var(--theme-hover, #f3f4f6)'};
  }

  .dark & {
    border-color: var(--theme-border, #374151);
    color: ${(props)=>props.active ? 'white' : 'var(--theme-text, #f3f4f6)'};
    
    &:hover {
      background-color: ${(props)=>props.active ? 'var(--theme-primary-dark, #059669)' : 'var(--theme-hover, #374151)'};
    }
  }
`;
const SearchResults = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
`;
const SearchResultItem = styled.div`
  padding: 0.75rem;
  border-bottom: 1px solid var(--theme-border, #e5e7eb);
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--theme-paper-hover, #f9fafb);
  }

  .dark & {
    border-color: var(--theme-border, #374151);
    
    &:hover {
      background-color: var(--theme-paper-hover, #374151);
    }
  }
`;
const SearchResultHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;
const SearchResultUser = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--theme-text-secondary, #6b7280);
  font-size: 0.875rem;
  font-weight: 500;

  .dark & {
    color: var(--theme-text-secondary, #9ca3af);
  }
`;
const SearchResultTime = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--theme-text-secondary, #6b7280);
  font-size: 0.75rem;
  margin-left: auto;

  .dark & {
    color: var(--theme-text-secondary, #9ca3af);
  }
`;
const SearchResultContent = styled.div`
  color: var(--theme-text, #111827);
  font-size: 0.875rem;
  line-height: 1.5;
  word-break: break-word;

  .dark & {
    color: var(--theme-text, #f3f4f6);
  }
`;
const SearchResultRoom = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--theme-primary, #10b981);
  font-size: 0.75rem;
  margin-top: 0.25rem;

  .dark & {
    color: var(--theme-primary, #10b981);
  }
`;
const StatusMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: ${(props)=>{
    switch(props.type){
        case 'error':
            return 'var(--theme-error, #dc2626)';
        case 'loading':
            return 'var(--theme-text-secondary, #6b7280)';
        default:
            return 'var(--theme-text-secondary, #6b7280)';
    }
}};
  font-size: 0.875rem;
  text-align: center;
`;
const LoadMoreButton = styled.button`
  width: 100%;
  padding: 0.75rem;
  border: none;
  background-color: var(--theme-paper-hover, #f9fafb);
  color: var(--theme-text, #111827);
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--theme-hover, #f3f4f6);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .dark & {
    background-color: var(--theme-paper-hover, #374151);
    color: var(--theme-text, #f3f4f6);
    
    &:hover {
      background-color: var(--theme-hover, #4b5563);
    }
  }
`;
const MessageSearch = ({ currentRoomId, onMessageClick, onClose })=>{
    const [searchTerm, setSearchTerm] = useState('');
    const [searchMode, setSearchMode] = useState('all');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    // 검색어 디바운싱
    useEffect(()=>{
        const timeoutId = setTimeout(()=>{
            setDebouncedSearchTerm(searchTerm);
        }, 300);
        return ()=>clearTimeout(timeoutId);
    }, [
        searchTerm
    ]);
    // 무한 스크롤 쿼리
    const { data, error, fetchNextPage, hasNextPage, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: [
            'searchMessages',
            searchMode,
            currentRoomId,
            debouncedSearchTerm
        ],
        queryFn: ({ pageParam = 0 })=>{
            if (!debouncedSearchTerm.trim()) {
                return Promise.resolve({
                    content: [],
                    number: 0,
                    size: 20,
                    totalElements: 0,
                    totalPages: 0,
                    last: true,
                    first: true
                });
            }
            if (searchMode === 'current' && currentRoomId) {
                return searchMessages(currentRoomId, debouncedSearchTerm, pageParam, 20);
            } else {
                return searchAllMessages(debouncedSearchTerm, pageParam, 20);
            }
        },
        getNextPageParam: (lastPage)=>{
            return lastPage.last ? undefined : lastPage.number + 1;
        },
        enabled: debouncedSearchTerm.trim().length > 0,
        staleTime: 1000 * 60 * 5
    });
    const handleClearSearch = useCallback(()=>{
        setSearchTerm('');
        setDebouncedSearchTerm('');
    }, []);
    const handleMessageClick = useCallback((message)=>{
        if (onMessageClick) {
            onMessageClick(message);
        }
    }, [
        onMessageClick
    ]);
    const formatTime = useCallback((timestamp)=>{
        const date = new Date(timestamp);
        const now = new Date();
        const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));
        if (diffInMinutes < 1) return '방금 전';
        if (diffInMinutes < 60) return `${diffInMinutes}분 전`;
        if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}시간 전`;
        if (diffInMinutes < 10080) return `${Math.floor(diffInMinutes / 1440)}일 전`;
        return date.toLocaleDateString('ko-KR', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    }, []);
    const highlightSearchTerm = useCallback((text, searchTerm)=>{
        if (!searchTerm) return text;
        const regex = new RegExp(`(${searchTerm})`, 'gi');
        const parts = text.split(regex);
        return parts.map((part, index)=>regex.test(part) ? /*#__PURE__*/ _jsx("span", {
                style: {
                    backgroundColor: 'var(--theme-primary-light, rgba(16, 185, 129, 0.2))',
                    fontWeight: 'bold'
                },
                children: part
            }, index) : part);
    }, []);
    const allMessages = data?.pages.flatMap((page)=>page.content) || [];
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsxs(SearchHeader, {
                children: [
                    /*#__PURE__*/ _jsxs(SearchInputContainer, {
                        children: [
                            /*#__PURE__*/ _jsx(Search, {
                                size: 20,
                                color: "var(--theme-text-secondary, #6b7280)"
                            }),
                            /*#__PURE__*/ _jsx(SearchInput, {
                                placeholder: "메시지 검색...",
                                value: searchTerm,
                                onChange: (e)=>setSearchTerm(e.target.value),
                                autoFocus: true
                            }),
                            searchTerm && /*#__PURE__*/ _jsx(ClearButton, {
                                onClick: handleClearSearch,
                                children: /*#__PURE__*/ _jsx(X, {
                                    size: 16
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(SearchFilters, {
                        children: [
                            /*#__PURE__*/ _jsx(FilterButton, {
                                active: searchMode === 'all',
                                onClick: ()=>setSearchMode('all'),
                                children: "전체 채팅방"
                            }),
                            currentRoomId && /*#__PURE__*/ _jsx(FilterButton, {
                                active: searchMode === 'current',
                                onClick: ()=>setSearchMode('current'),
                                children: "현재 채팅방"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(SearchResults, {
                children: [
                    status === 'loading' && /*#__PURE__*/ _jsx(StatusMessage, {
                        type: "loading",
                        children: "검색 중..."
                    }),
                    status === 'error' && /*#__PURE__*/ _jsxs(StatusMessage, {
                        type: "error",
                        children: [
                            "검색 중 오류가 발생했습니다.",
                            /*#__PURE__*/ _jsx("button", {
                                onClick: ()=>refetch(),
                                style: {
                                    marginTop: '0.5rem',
                                    padding: '0.5rem 1rem',
                                    backgroundColor: 'var(--theme-primary, #10b981)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '0.25rem',
                                    cursor: 'pointer'
                                },
                                children: "다시 시도"
                            })
                        ]
                    }),
                    status === 'success' && !debouncedSearchTerm && /*#__PURE__*/ _jsx(StatusMessage, {
                        type: "empty",
                        children: "검색어를 입력하세요"
                    }),
                    status === 'success' && debouncedSearchTerm && allMessages.length === 0 && /*#__PURE__*/ _jsxs(StatusMessage, {
                        type: "empty",
                        children: [
                            '"',
                            debouncedSearchTerm,
                            '"에 대한 검색 결과가 없습니다'
                        ]
                    }),
                    allMessages.map((message, index)=>/*#__PURE__*/ _jsxs(SearchResultItem, {
                            onClick: ()=>handleMessageClick(message),
                            children: [
                                /*#__PURE__*/ _jsxs(SearchResultHeader, {
                                    children: [
                                        /*#__PURE__*/ _jsxs(SearchResultUser, {
                                            children: [
                                                /*#__PURE__*/ _jsx(User, {
                                                    size: 14
                                                }),
                                                message.sender?.displayName || message.sender?.userName || '알 수 없음'
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(SearchResultTime, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Clock, {
                                                    size: 12
                                                }),
                                                formatTime(message.createdAt)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(SearchResultContent, {
                                    children: highlightSearchTerm(message.content, debouncedSearchTerm)
                                }),
                                message.roomName && /*#__PURE__*/ _jsxs(SearchResultRoom, {
                                    children: [
                                        /*#__PURE__*/ _jsx(MessageCircle, {
                                            size: 12
                                        }),
                                        message.roomName
                                    ]
                                })
                            ]
                        }, `${message.id}-${index}`)),
                    hasNextPage && /*#__PURE__*/ _jsx(LoadMoreButton, {
                        onClick: ()=>fetchNextPage(),
                        disabled: isFetchingNextPage,
                        children: isFetchingNextPage ? '로딩 중...' : '더 보기'
                    })
                ]
            })
        ]
    });
};
export default MessageSearch;
